import React from 'react';
import './Wettkampf30.css';

function Durchgang30({requiredStarters, wettkampfData, collectedErgebnisData}) {
    return (
        <div>
            {wettkampfData && (
                <div>
                    {Object.keys(wettkampfData).map((durchgang, index) => (
                            <div key={index}>
                                <h3>Durchgang {durchgang}</h3>
                                {wettkampfData[durchgang].map(wettkampf => {
                                    const resultsList = collectedErgebnisData.filter(result =>
                                        result.durchgang.toString() === durchgang &&
                                        result.wettkampfId === wettkampf.wettkampfId).sort((a, b) => a.position - b.position);
                                    const sumHeim = resultsList.reduce((sum, result) => {
                                        const isMandatory = result.position <= requiredStarters;
                                        const value = isMandatory ? parseInt(result.gesamtHeim, 10) : 0;
                                        return sum + value;
                                    }, 0);
                                    const sumFern = resultsList.reduce((sum, result) => {
                                        const isMandatory = result.position <= requiredStarters;
                                        const value = isMandatory ? parseInt(result.gesamtFern, 10) : 0;
                                        return sum + value;
                                    }, 0);
                                    return (
                                        <div key={wettkampf.id}>
                                            <div className="grid-wettkampf">
                                                <div className="mannschaft-heim">
                                                    <div>{wettkampf.mannschaftHeimName}</div>
                                                </div>
                                                <div className="mannschaft-heim-punkte">
                                                    <div>{wettkampf.mannschaftHeimEinzelpunkte}</div>
                                                </div>
                                                <div className="vs">
                                                    <div>:</div>
                                                </div>
                                                <div className="mannschaft-fern-punkte">
                                                    <div>{wettkampf.mannschaftFernEinzelpunkte}</div>
                                                </div>
                                                <div className="mannschaft-fern">
                                                    <div>{wettkampf.mannschaftFernName}</div>
                                                </div>
                                                {wettkampf.reasonHeim === 1 && (
                                                    <div className="message-30-heim">
                                                        - Mannschaft nicht angetreten -
                                                    </div>
                                                )}
                                                {wettkampf.reasonFern === 1 && (
                                                    <div className="message-30-fern">
                                                        - Mannschaft nicht angetreten -
                                                    </div>
                                                )}
                                                {wettkampf.reasonHeim === 2 && (
                                                    <div className="message-30-heim">
                                                        - Ergebnisse verspätet gemeldet -
                                                    </div>
                                                )}
                                                {wettkampf.reasonFern === 2 && (
                                                    <div className="message-30-fern">
                                                        - Ergebnisse verspätet gemeldet -
                                                    </div>
                                                )}
                                                {wettkampf.reasonHeim === 3 && (
                                                    <div className="message-30-heim">
                                                        - Mannschaft zurückgezogen -
                                                    </div>
                                                )}
                                                {wettkampf.reasonFern === 3 && (
                                                    <div className="message-30-fern">
                                                        - Mannschaft zurückgezogen -
                                                    </div>
                                                )}
                                            </div>
                                            {resultsList && (
                                                <div>
                                                    {resultsList.map((result, index) => (
                                                        <div className="grid-ergebnis-30" key={index}>
                                                            {result.gesamtHeim && wettkampf.freigabeHeim && result.reasonHeim !== 1 && (
                                                                <>
                                                                    <div className="scheibe-heim-30">({result.scheibenNrHeim})</div>
                                                                    <div className="name-heim-30"> {result.personNachnameHeim}, {result.personVornameHeim}</div>
                                                                    <div className="s1-heim-30">{result.s1Heim}</div>
                                                                    <div className="s2-heim-30">{result.s2Heim}</div>
                                                                    <div className="s3-heim-30">{result.s3Heim}</div>
                                                                    <div className="gesamt-heim-30">{result.gesamtHeim}</div>
                                                                    <div className="punkt-heim-30">{result.einzelpunktHeim}</div>
                                                                </>
                                                            )}
                                                            {result.gesamtHeim && result.gesamtFern && result.reasonHeim !== 1 && result.reasonFern !== 1 &&(
                                                                <>
                                                                    <div className="vs-ergebnis-30">:</div>
                                                                </>
                                                            )}
                                                            {result.gesamtFern && wettkampf.freigabeFern && result.reasonFern !== 1 && (
                                                                <>
                                                                    <div className="punkt-fern-30">{result.einzelpunktFern}</div>
                                                                    <div className="gesamt-fern-30">{result.gesamtFern}</div>
                                                                    <div className="s1-fern-30">{result.s1Fern}</div>
                                                                    <div className="s2-fern-30">{result.s2Fern}</div>
                                                                    <div className="s3-fern-30">{result.s3Fern}</div>
                                                                    <div className="name-fern-30"> {result.personNachnameFern}, {result.personVornameFern}</div>
                                                                    <div className="scheibe-fern-30">({result.scheibenNrFern})</div>
                                                                </>
                                                            )}
                                                        </div>
                                                    ))}
                                                    {wettkampf.freigabeHeim && wettkampf.freigabeFern && (
                                                        <div className="grid-ergebnis-40">
                                                            {sumHeim > 0 && (
                                                                <div className="sum-heim">( {sumHeim} )</div>
                                                            )}
                                                            {sumFern > 0 && (
                                                                <div className="sum-fern"> ( {sumFern} )</div>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    )
                                })}
                            </div>
                        )
                    )
                    }
                </div>
            )
            }
        </div>
    )
}

export default Durchgang30;
